import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//PNG Images
import Apps from "../../assets/png/appsicon.png";
// import Logo from "../../assets/png/logoicon.png";

//SVG Images
import Bell from "../../assets/svg/bellicon.svg";
import FAQ from "../../assets/svg/faq-ic.svg";
import Settings from "../../assets/svg/settingsicon.svg";
import Profile from "../../assets/svg/profileicon.svg";
import Logo from "../../assets/svg/crm_logo.svg";
import {
  getOrgLogoApi,
  getProfileDetailsApi,
  getOrgListApi,
} from "./common-api";
import ReportAnIssueModal from "../common/report-an-issue-modal";
import ProfilePopup from "./ProfilePopup";
import NotificationPopup from "./NotificationPopup";
import issue from "../../assets/svg/issue.svg";
import "./topbar.css";

const Topbar = () => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();
  const [profileDetail, setProfileDetail] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showComplaintModule, setShowComplaintModule] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [orgLogo, setOrgLogo] = useState("");
  const [orgName, setOrgName] = useState("");
  const [firstLetter, setFirstLetter] = useState("");

  const handleOpenV1Modal = () => {
    window.dispatchEvent(new CustomEvent("open-v1-migration-modal"));
  };
  useEffect(() => {
    getOrgList();
    getOrgLogo();
    getProfileDetails();
  }, []);
  const [orgList, setOrgList] = useState([]);
  const getOrgList = async () => {
    console.log("Getting org list");
    const response = await getOrgListApi();
    console.log(response.data);
    if (response.status === 200) {
      console.log(response.data.orgs);
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        /*  setheaderDetails(response.user ?? {}); */
        setOrgLogo(response.image ?? "");
        setOrgName(response.org_name ?? "....");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getProfileDetails = async () => {
    try {
      const response = await getProfileDetailsApi();

      if (!response) {
        console.error("No response received from API");
        return;
      }

      if (response.status === 200 && response.data?.success) {
        setProfileDetail(response.data.user);
        setFirstLetter(
          response.data.user?.first_name
            ? response.data.user.first_name.charAt(0)
            : "",
        );
      }
    } catch (err) {
      console.error("Error in getProfileDetails:", err);
    }
  };

  return (
    <>
      {showNotifications && (
        <NotificationPopup
          notifications={notifications}
          onClose={() => setShowNotifications(false)}
        />
      )}
      {showComplaintModule && (
        <ReportAnIssueModal
          onSuccess={() => {
            setShowComplaintModule(false);
          }}
          onCancel={() => {
            setShowComplaintModule(false);
          }}
        />
      )}
      {showPopup && (
        <ProfilePopup
          orgList={orgList}
          profileDetail={profileDetail}
          onClose={() => setShowPopup(false)}
          orgLogo={orgLogo}
          orgName={orgName}
          callProfileFunc={getProfileDetails}
        />
      )}
      <div
        style={{
          fontFamily: "'Euclid Circular B', sans-serif",
          height: "64px",
          width: "100%",
          overflowX: "hidden",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid #EBEBEB",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <img
            src={Apps}
            style={{ width: "44px", height: "44px", cursor: "pointer" }}
            alt="Apps"
            onClick={() => {
              window.open(accountsUrl, "_blank", "noopener,noreferrer");
            }}
          />
          {/* <img src={orgLogo != null && orgLogo !== "" ? orgLogo : Logo} style={{ maxHeight: "40px" }} alt="Logo" /> */}

          <img
            src={orgLogo != null && orgLogo !== "" ? orgLogo : Logo}
            alt=""
            style={{ maxHeight: "26px" }}
          />
          <div
            style={{
              fontWeight: "500",
              fontSize: "20px",
              color: "#172B4D",
              paddingLeft: "8px",
            }}
          >
            CRM
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button
            type="button"
            className="topbar-v1-btn"
            onClick={handleOpenV1Modal}
            title="Switch to CRM V1.0"
          >
            <svg
              width="19"
              height="19"
              viewBox="0 0 24 24"
              fill="none"
              className="topbar-v1-sparkle"
            >
              <path
                d="M 11 2 C 11 6.5 7.5 10 3 10 C 7.5 10 11 13.5 11 18 C 11 13.5 14.5 10 19 10 C 14.5 10 11 6.5 11 2 Z"
                stroke="#6929E2"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M 19 2 V 6 M 17 4 H 21"
                stroke="#6929E2"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle cx="4.5" cy="17" r="1.6" fill="#6929E2" />
            </svg>
            <span className="topbar-v1-text">V1.0</span>
          </button>
          <div className="right_divs">
            <button
              onClick={() => {
                setShowComplaintModule(true);
              }}
              type="button"
              className="right_divs px-2"
              style={{
                width: "152px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                columnGap: "8px",
                fontSize: "13px",
                border: "none",
                borderRadius: "12px",
                backgroundColor: "#F8F8F8",
                color: "#172B4D",
                fontWeight: "500",
              }}
            >
              <img
                src={issue}
                alt="issue"
                srcSet=""
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
              <span>Report an issue</span>
            </button>
          </div>
          {/* <img src={Bell} style={{ width: "44px", height: "44px", cursor: "pointer" }} alt="Notifications" onClick={() => setShowNotifications(!showNotifications)} /> */}
          <div className="d-flex align-items-center gap-3">
            <img
              src={FAQ}
              style={{ width: "19px", height: "19px", cursor: "pointer" }}
              alt="Help"
              onClick={() => {
                navigate("/help");
              }}
            />
            {/* <img src={Settings} style={{ width: "44px", height: "44px" }} alt="Settings" /> */}
            <div
              onClick={() => {
                setShowPopup(!showPopup);
              }}
              style={{ cursor: "pointer", paddingRight: "16px" }}
            >
              {profileDetail.profile_image != null &&
                profileDetail.profile_image !== "" && (
                  <img
                    src={profileDetail.profile_image}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "100px",
                      border: "1px solid #8790A1",
                      fit: "cover",
                    }}
                    alt="Profile"
                  />
                )}
              {(profileDetail.profile_image == null ||
                profileDetail.profile_image === "") && (
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transparent",
                    border: "1px solid #8790A1",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#FFFFFF",
                    }}
                  >
                    {firstLetter}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Topbar;
